var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-content",
        [
          !_vm.isPageLoaded ? _c("Start") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c("Menu"),
              _vm._v(" "),
              _c("div", {
                staticClass: "secondary",
                staticStyle: {
                  "border-top": "5px solid #777adb",
                  width: "100%"
                }
              }),
              _vm._v(" "),
              _vm.isPageLoaded
                ? _c(
                    "v-layout",
                    { attrs: { row: "", id: "divMain" } },
                    [
                      _c("v-flex", { attrs: { sm3: "" } }, [_c("DbInfo")], 1),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { sm9: "", id: "divQueryExecutorContainer" } },
                        [_c("QueryExecutor")],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }